module.exports = __webpack_public_path__ + "static/media/board_Omar-Sweeney.507582dd.jpg";